/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byline_SourceInputs */

const en_byline_source = /** @type {(inputs: Byline_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View source`)
};

const ko_byline_source = /** @type {(inputs: Byline_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소스 보기`)
};

const ja_byline_source = /** @type {(inputs: Byline_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースを見る`)
};

/**
* | output |
* | --- |
* | "View source" |
*
* @param {Byline_SourceInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const byline_source = /** @type {((inputs?: Byline_SourceInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byline_SourceInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_byline_source(inputs)
	if (locale === "ko") return ko_byline_source(inputs)
	return ja_byline_source(inputs)
});